import React from 'react';
import {  Input} from 'reactstrap';

const PaginationRightSide = ({
	setPageSize,
	pageSize,
	gotoPage
}) => {
	const onPageSizeChange = (e) => {
		setPageSize(Number(e.target.value));
		gotoPage(0)
	}
	return (
		<>
			Display
			<Input
				type="select"
				id="pageshow"
				bsSize="sm"
				value={pageSize}
				className="font16 pageShow"
				onChange={onPageSizeChange}
			>
				{[ 10,20,50, 100, 200, 300, 400, 500 ].map((pageSize) => (
					<option key={pageSize} value={pageSize}>
						{pageSize}
					</option>
				))}
			</Input>
			records
		</>
	);
};

export default PaginationRightSide;
